import { BlablacarThemeProvider } from "@obs/base";
import { Locale } from "@obs/providers";
import { IntlProvider } from "react-intl";

import { useLocaleCacheInvalidator } from "./Hooks/useLocaleCacheInvalidator";
import { SupportedLocale } from "./intl/constants";
import { getMessages } from "./intl/getMessages";
import { Router } from "./Router";

export const App = () => {
	const locale = Locale.useCurrentLocale();
	useLocaleCacheInvalidator();

	return (
		<IntlProvider locale={locale} messages={getMessages(locale as SupportedLocale)}>
			<BlablacarThemeProvider>
				<Router />
			</BlablacarThemeProvider>
		</IntlProvider>
	);
};
